module.exports = __webpack_public_path__ + "media/images/app/products/index/styles/rings/gemstone-cocktail-5c2e8f2f443da0bbc5ba2bc7745d7e96.webp";